import { render, staticRenderFns } from "./ClientHeaderTabs.vue?vue&type=template&id=53227e1c&"
import script from "./ClientHeaderTabs.vue?vue&type=script&lang=js&"
export * from "./ClientHeaderTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports